/**
 * Filtro y estadísticas del registro (auditoria.html): funciones puras,
 * separadas de la página para poder testearlas sin montar React (mismo
 * patrón que estado.ts/fecha.ts en implantaciones).
 */
import { refTexto, type Acto, type ActoTipo, type ActorTipo } from "./auditoria.seed";

export interface FiltroActos { q: string; tipo: ActoTipo | ""; actor: ActorTipo | "" }

/** Búsqueda por acto, actor o «dónde» — el mismo campo que el prototipo (la referencia no entra en la búsqueda). */
export function filtrarActos(actos: readonly Acto[], f: FiltroActos): Acto[] {
  const q = f.q.trim().toLowerCase();
  return actos.filter((a) => {
    const texto = `${a.actoTexto} ${a.actor} ${refTexto(a.donde)}`.toLowerCase();
    return (!q || texto.includes(q)) && (!f.tipo || a.tipo === f.tipo) && (!f.actor || a.actorTipo === f.actor);
  });
}

export interface StatsDia { total: number; respuestas: number; memoria: number; cola: number; sistema: number; curacion: number }

/** El día en números (sidepane): recuento por tipo, derivado del registro — nunca un número aparte a mantener a mano. */
export function statsDia(actos: readonly Acto[]): StatsDia {
  const cuenta = (t: ActoTipo) => actos.filter((a) => a.tipo === t).length;
  return { total: actos.length, respuestas: cuenta("respuesta"), memoria: cuenta("memoria"), cola: cuenta("cola"), sistema: cuenta("sistema"), curacion: cuenta("curacion") };
}
